module.exports = __webpack_public_path__ + "static/media/france.b4ef139b.svg";